import {apiAddress, apiClient} from '../services/api';
import log from 'loglevel'
import {Buffer} from 'buffer';
// import {  Trans, t } from 'react-i18next'; 
import {t} from 'i18next'

import {
    AUTHENTICATE_USER,
    DEAUTHENTICATE_USER,
    ERROR,
    CLEAR_ERROR,
  } from './reducer';
import toast from "../utils/ToasterService";
import 'react-toastify/dist/ReactToastify.css'


/**
 * authenticate
 * @return {Array} of Entries
 */
export function authenticate(username, password) {
    const url = `${apiAddress}/auth/`;
    const hash = Buffer.from(`${username}:${password}`).toString('base64');
    return dispatch =>
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Basic ${hash}`,
          'cache-control': 'no-cache',
        },
      })
        .then((response) => {
          if (response.ok === true) {
            return response.json();
          }
          dispatch(hasError(response.status, response.statusText));
        })
        .then((json) => {
          if(!json) return;
          
          if (json.type && json.type === 'ERROR') {
              log.error("ERROR")
          toast.error(t('Authentication.toast_error') );
            return dispatch(hasError(json.param, json.message));
          }
          apiClient.defaults.headers.common['Authorization'] = "Bearer " +json.token;
          return dispatch(_authenticate(json.token, json.user));
        })
        .catch((e) => {
          dispatch(hasError(e.message, e));
        });
  }

/**
 * authenticate
 * @return {Array} of Entries
 */
  export function deauthenticate() {
      return (dispatch) => {
          apiClient.get('auth/logout').finally(() => {
              apiClient.defaults.headers.common['Authorization'] = "";
              dispatch( {
                  type: DEAUTHENTICATE_USER,
              });
          })
      }


  }

  /**
   *
   * @return {Action}           action
   */
  function _authenticate(token, user) {
    return {
      type: AUTHENTICATE_USER,
      token,
      user,
    };
  }

  /**
   * hasError
   * @param {string}   cause
   * @param {Object}  exception
   * @return {Action}   action
   */
function hasError(param, message) {
    // log.error(param)
    if (param === "Request failed with status code 401") {
      return { type: DEAUTHENTICATE_USER}
    }
  return { type: ERROR, param, message };
}

export function clearError() {
  return { type: CLEAR_ERROR };
}
  
